import { request } from '@api/request'
import { ReleaseData, ReleaseDataInfo } from '@models/ReleaseNews'
import { AxiosResponse } from 'axios'

export const releaseData = {
  getReleases: function (): Promise<AxiosResponse> {
    return request.get<ReleaseDataInfo[]>('release/getAllReleases')
  },

  getReleaseNews: function (id?: number): Promise<AxiosResponse> {
    return request.get<ReleaseData>('release/getRelease', {
      params: { idVersion: id }
    })
  },
  getReleaseThumbnail: function (id?: number): Promise<AxiosResponse> {
    return request.get('release/getVersionImage', {
      params: { id: id }
    })
  }
}
